import { render, staticRenderFns } from "./CertificadoEditar.vue?vue&type=template&id=77cfcd73"
import script from "./CertificadoEditar.vue?vue&type=script&lang=js"
export * from "./CertificadoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports